(() => {
  'use strict';

  const status = (message) => {
    const region = document.getElementById('tp-a11y-status');
    if (!region || !message) return;
    region.textContent = '';
    window.setTimeout(() => { region.textContent = message; }, 20);
  };

  const initTabs = (root = document) => {
    root.querySelectorAll('[data-a11y-tabs]').forEach((tablist) => {
      if (tablist.dataset.a11yReady === 'true') return;
      tablist.dataset.a11yReady = 'true';
      const wrapper = tablist.closest('.tp-product-horizontal-tabs');
      if (!wrapper) return;
      const tabs = Array.from(tablist.querySelectorAll('[data-a11y-tab]'));
      const panels = Array.from(wrapper.querySelectorAll('[data-a11y-tab-panel]'));

      const activate = (tab, setFocus = false) => {
        const inputId = tab.getAttribute('for');
        const input = inputId && document.getElementById(inputId);
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
          const active = panel.id === tab.getAttribute('aria-controls');
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');
          panel.tabIndex = active ? 0 : -1;
        });
        if (setFocus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); activate(tab); return; }
          else return;
          event.preventDefault();
          activate(tabs[next], true);
        });
      });
      activate(tabs.find(t => t.getAttribute('aria-selected') === 'true') || tabs[0]);
    });
  };

  const initSearchDetails = (root = document) => {
    root.querySelectorAll('details.tp-search-drawer').forEach((details) => {
      if (details.dataset.a11yReady === 'true') return;
      details.dataset.a11yReady = 'true';
      const summary = details.querySelector('summary.tp-search-toggle');
      const input = details.querySelector('input[type="search"]');
      if (!summary) return;
      const sync = () => {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        summary.setAttribute('aria-label', details.open ? 'Close search' : 'Open search');
        if (details.open && input) window.setTimeout(() => input.focus(), 40);
      };
      details.addEventListener('toggle', sync);
      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          details.open = false;
          summary.focus();
        }
      });
      sync();
    });
  };

  const initScoopPopups = (root = document) => {
    root.querySelectorAll('[data-scoop-item]').forEach((item) => {
      if (item.dataset.a11yPopupReady === 'true') return;
      item.dataset.a11yPopupReady = 'true';
      const trigger = item.querySelector('[data-scoop-trigger]');
      const popup = item.querySelector('[data-scoop-popup]');
      const close = item.querySelector('[data-scoop-close]');
      if (!trigger || !popup) return;
      popup.setAttribute('role', 'region');
      popup.setAttribute('aria-label', 'Ingredient details');
      trigger.addEventListener('click', () => {
        if (trigger.getAttribute('aria-expanded') === 'true' && close) window.setTimeout(() => close.focus(), 20);
      });
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') {
          event.preventDefault();
          if (close) close.click();
          trigger.focus();
        }
      });
      if (close) close.addEventListener('click', () => window.setTimeout(() => trigger.focus(), 0));
    });
  };

  const enhanceExternalLinks = (root = document) => {
    root.querySelectorAll('a[target="_blank"]').forEach((link) => {
      if (link.dataset.a11yNewWindow === 'true') return;
      link.dataset.a11yNewWindow = 'true';
      const hidden = document.createElement('span');
      hidden.className = 'tp-visually-hidden';
      hidden.textContent = ' (opens in a new window)';
      link.appendChild(hidden);
    });
  };



  const initQuantityControls = (root = document) => {
    root.querySelectorAll('.tp-qty').forEach((group) => {
      if (group.dataset.a11yQtyReady === 'true') return;
      group.dataset.a11yQtyReady = 'true';

      const input = group.querySelector('input[name="quantity"]');
      const minus = group.querySelector('[data-qty-minus]');
      const plus = group.querySelector('[data-qty-plus]');
      if (!input || !minus || !plus) return;

      const number = (value, fallback) => {
        const parsed = parseInt(value, 10);
        return Number.isFinite(parsed) ? parsed : fallback;
      };

      const sync = (announce = false) => {
        const min = number(input.min, 1);
        const max = input.max ? number(input.max, Infinity) : Infinity;
        let value = number(input.value, min);
        value = Math.max(min, Math.min(max, value));
        input.value = value;

        minus.disabled = value <= min;
        minus.setAttribute('aria-disabled', minus.disabled ? 'true' : 'false');
        plus.disabled = value >= max;
        plus.setAttribute('aria-disabled', plus.disabled ? 'true' : 'false');

        if (announce) status(`Quantity ${value}.`);
      };

      minus.addEventListener('click', () => window.setTimeout(() => sync(true), 0));
      plus.addEventListener('click', () => window.setTimeout(() => sync(true), 0));
      input.addEventListener('change', () => sync(true));
      sync(false);
    });
  };

  const enhanceButtons = (root = document) => {
    root.querySelectorAll('button[disabled], input[disabled]').forEach((control) => {
      control.setAttribute('aria-disabled', 'true');
    });
  };

  const init = (root = document) => {
    initTabs(root);
    initSearchDetails(root);
    initScoopPopups(root);
    initQuantityControls(root);
    enhanceButtons(root);
    enhanceExternalLinks(root);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('submit', (event) => {
    if (event.target.matches('form[action*="/cart/add"]')) status('Adding item to cart.');
  });
})();
